const requireAll = requireContext => requireContext.keys().map(requireContext);
// import all svg
const req = require.context('../../assets/svg-icon/', true, /\.svg$/);
requireAll(req);